
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/upgrade-to-v10",
      function () {
        return require("private-next-pages/material-ui/migration/upgrade-to-v10.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/upgrade-to-v10"])
      });
    }
  